import { IPitchFilter, IPitchValue, emptyPitch } from "../abstraction/IPitchFilter";

export class OutOfRange implements IPitchFilter {


    processSample(value: IPitchValue): IPitchValue {

        if (value.pitch > 6000 || value.pitch < 20 || !isFinite(value.pitch) || isNaN(value.pitch))
            return emptyPitch(value);
        return value;
    }
     

    readonly rawData: IPitchValue[] = [];

}